import TrimList from './ui/TrimList'
const TrimPage = () => {
	return <TrimList />
}

export default TrimPage
